<template>
    <div id="inactivityModal" class="modal fade" tabindex="-1" role="dialog">
        <div id="inactivity-modal-dialog" class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Inactivity Timeout</h5>
                </div>
                <div class="modal-body">
                    <div class="container text-center font-weight-bold p-2">
                        <div class="h4">Are you still using Worx?</div>
                        <div class="h5">For security reasons, due to inactivity you will be signed out in:</div>
                        <div class="text-center text-danger h2">{{ time }}</div>
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
                    <button type="button" class="btn btn-primary pl-5 pr-5" @click="close()">Continue</button>
                    <button type="button" class="btn btn-secondary pl-5 pr-5" @click="logout()">Sign Out</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        timeout: Number,
        responseTimeout: Number,
    },
    data() { 
        return {
            warningWorker: null,
            logoutWorker: null,
            events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'touchmove', 'load'],
            date: moment(0),
        }
    },

    computed: {
        time: function () {
            return this.date.format('mm:ss');
        }
    },     

    mounted() {
        this.startWarningTimer();
    },

    destroyed() {
        this.stopWarningTimer();
    },

    methods: {
        startWarningTimer: function () {

            if (typeof(Worker) !== 'undefined') {

                let blobURL = window.URL.createObjectURL(new Blob([ '(',

                function () {

                    let timeoutId;

                    onmessage = (e) => {

                        let command = e.data[0];
                        let timeoutMilliseconds = (e.data.length === 2) ? (e.data[1] * 60 * 1000) : null;

                        switch(command) {
                            case 'start':
                                timeoutId = setTimeout(() => { postMessage(true); }, timeoutMilliseconds);
                                break;
                            case 'reset':
                                clearTimeout(timeoutId);
                                timeoutId = setTimeout(() => { postMessage(true); }, timeoutMilliseconds);
                                break;
                            case 'stop':
                                clearTimeout(timeoutId);  
                                break;
                        }
                    }

                }.toString(),

                ')()'], { type: 'application/javascript' }));

                // create the web worker to run the timer
                this.warningWorker = new Worker(blobURL);
                this.warningWorker.onmessage = (e) => {
                    this.showModal();
                }
                this.warningWorker.postMessage(['start', this.timeout]);

                // we don't need this anymore so we can free memory
                window.URL.revokeObjectURL(blobURL);

                // listen for events that indicate the user is still using the site
                this.events.forEach((event) => {
                    window.addEventListener(event, this.resetWarningTimer);
                }, this);
            }
            else {
                console.log('Web Worker is not supported.');
            }
        },
        stopWarningTimer: function () {

            // unregister the event listeners
            this.events.forEach((event) => {
                window.removeEventListener(event, this.resetTimer);
            }, this);

            // stop the warning timer
            this.warningWorker.postMessage(['stop']);
            this.warningWorker.terminate();
        },
        resetWarningTimer: function () {
            this.warningWorker.postMessage(['reset', this.timeout]);
        },        
        showModal: function () {
            this.stopWarningTimer();
            $('#inactivityModal').modal({ backdrop: 'static', keyboard: false });
            this.startLogoutTimer();            
        },
        startLogoutTimer: function () {

            this.date =  moment(this.responseTimeout * 60 * 1000);
            if (typeof(Worker) !== 'undefined') {

                let blobURL = window.URL.createObjectURL(new Blob([ '(',

                function () {

                    const intervalMilliseconds = 1000; // 1 second 
                    let intervalId;

                    onmessage = (e) => {

                        switch(e.data) {
                            case 'start':
                                intervalId = setInterval(() => { postMessage(true); }, intervalMilliseconds);
                                break;
                            case 'reset':
                                clearInterval(intervalId);
                                intervalId = setInterval(() => { postMessage(true); }, intervalMilliseconds);
                                break;
                            case 'stop':
                                clearInterval(intervalId);
                                break;
                        }
                    }
                }.toString(),

                ')()'], { type: 'application/javascript' }));

                // create the web worker to run the timer
                this.logoutWorker = new Worker(blobURL);
                this.logoutWorker.onmessage = (e) => {
                    this.updateTime();
                }
                this.logoutWorker.postMessage('start');

                // we don't need this anymore so we can free memory
                window.URL.revokeObjectURL(blobURL);
            }
            else {
                console.log('Web Worker is not supported.');
            }
        },
        stopLogoutTimer: function () {

            // stop the logout timer
            this.logoutWorker.postMessage('stop');
            this.logoutWorker.terminate();
            this.date = moment(0);
        },
        updateTime: function() {
            this.date = moment(this.date.subtract(1, 'seconds'));
            if (this.time == '00:00') {
                this.logout();
            }
        },        
        logout: function () {

            // stop the logout timer and logout of the application
            this.stopLogoutTimer();
            document.getElementById('logout-form').submit();
        },
        close: function () {

            $('#inactivityModal').modal('hide');
            this.stopLogoutTimer();
            this.startWarningTimer();
        }
    }
}
</script>